module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-input-number",
    class: [
      _vm.size ? 'is-' + _vm.size : '',
      {
        'is-disabled': _vm.disabled
      }
    ]
  }, [_c('i-input', {
    class: {
      'is-active': _vm.inputActive
    },
    attrs: {
      "disabled": _vm.disabled,
      "size": _vm.size,
      "number": true
    },
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "repeat-click",
      rawName: "v-repeat-click",
      value: (_vm.decrease),
      expression: "decrease"
    }],
    staticClass: "el-input-number-decrease el-icon-minus",
    class: {
      'is-disabled': _vm.minDisabled
    },
    on: {
      "mouseenter": function($event) {
        _vm.activeInput(_vm.minDisabled)
      },
      "mouseleave": function($event) {
        _vm.inactiveInput(_vm.minDisabled)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "repeat-click",
      rawName: "v-repeat-click",
      value: (_vm.increase),
      expression: "increase"
    }],
    staticClass: "el-input-number-increase el-icon-plus",
    class: {
      'is-disabled': _vm.maxDisabled
    },
    on: {
      "mouseenter": function($event) {
        _vm.activeInput(_vm.maxDisabled)
      },
      "mouseleave": function($event) {
        _vm.inactiveInput(_vm.maxDisabled)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-33fad5cd!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/input-number/src/input-number.vue
// module id = 637
// module chunks = 0